// InactivityTimeout.js

class InactivityTimeout {
    constructor(timeoutDuration, logoutCallback) {
        this.timeoutDuration = timeoutDuration;
        this.logoutCallback = logoutCallback;
        this.inactivityTimeout = null;

        this.startInactivityTimer();
        this.setupEventListeners();
    }

    startInactivityTimer() {
        this.clearInactivityTimer();
        this.inactivityTimeout = setTimeout(() => {
            this.logoutCallback();
        }, this.timeoutDuration);
    }

    resetInactivityTimer() {
        this.startInactivityTimer();
    }

    clearInactivityTimer() {
        clearTimeout(this.inactivityTimeout);
    }

    setupEventListeners() {
        document.addEventListener('mousemove', () => this.resetInactivityTimer());
        document.addEventListener('keydown', () => this.resetInactivityTimer());
        // Add more event listeners for other user interactions as needed
    }
}

export default InactivityTimeout;
